import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_4 = {
  class: "min-h-0 flex-1 overflow-y-auto px-6 py-5"
};
const _hoisted_5 = {
  class: "grid grid-cols-1 gap-4 md:grid-cols-2"
};
const _hoisted_6 = {
  key: 0,
  class: "monthly-company-summary md:col-span-2 rounded-lg border border-slate-200 bg-slate-50 px-4 py-3"
};
const _hoisted_7 = {
  class: "mt-1 truncate text-sm font-medium text-slate-900"
};
const _hoisted_8 = {
  key: 1,
  class: "block md:col-span-2"
};
const _hoisted_9 = {
  key: 2,
  class: "block"
};
const _hoisted_10 = {
  class: "block"
};
const _hoisted_11 = {
  class: "form-label"
};
const _hoisted_12 = {
  key: 0,
  class: "text-red-500"
};
const _hoisted_13 = {
  class: "block"
};
const _hoisted_14 = {
  key: 0,
  class: "mt-1 text-xs text-amber-600"
};
const _hoisted_15 = {
  class: "block"
};
const _hoisted_16 = {
  key: 0,
  class: "mt-1 text-xs text-amber-600"
};
const _hoisted_17 = {
  class: "md:col-span-2"
};
const _hoisted_18 = {
  class: "md:col-span-2"
};
const _hoisted_19 = {
  class: "md:col-span-2"
};
const _hoisted_20 = {
  class: "flex justify-end gap-3 border-t border-slate-200 px-6 py-4"
};
const _hoisted_21 = ["disabled"];
const _hoisted_22 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
import { addEnterpriseInvoicePlanCustomer, updateEnterpriseInvoicePlanCustomer } from '@/api/invoice';
import { formatInvoiceAmount, normalizeAmountInput, parsePercentInput, toPercentInput } from '../utils';
import { defaultProductQuotas, normalizeProductQuotas, quotaTotalMatched, validateProductQuotaList } from '../productQuota';
import InvoiceCustomerInvoiceRulePanel from './InvoiceCustomerInvoiceRulePanel.vue';
import InvoiceProductQuotaEditor from './InvoiceProductQuotaEditor.vue';
export default {
  __name: 'InvoiceCustomerModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    planId: {
      type: [Number, String],
      default: null
    },
    customer: {
      type: Object,
      default: null
    },
    regions: {
      type: Array,
      default: () => []
    },
    downstreamAllocations: {
      type: Array,
      default: () => []
    },
    downstreamTagPreferences: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'saved', 'configure-downstream', 'configure-tag-preference'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      id: null,
      customerId: null,
      companyName: '',
      registeredRegion: '',
      regionBucketId: null,
      targetOutputAmount: null,
      targetProfitRatePercent: '',
      inputProductQuotas: defaultProductQuotas(0),
      outputProductQuotas: defaultProductQuotas(0)
    });
    const submitting = ref(false);
    const amountWarning = ref('');
    const isEditMode = computed(() => Boolean(form.id));
    const modalTitle = computed(() => isEditMode.value ? '编辑当月客户' : '新增当月客户');
    const isFullProfitRate = computed(() => parsePercentInput(form.targetProfitRatePercent) === 1);
    const normalizedTargetAmount = computed(() => normalizeAmountInput(form.targetOutputAmount) || 0);
    const invoiceRuleCustomer = computed(() => ({
      ...props.customer,
      id: form.id,
      planCustomerId: form.id,
      targetOutputAmount: normalizedTargetAmount.value,
      targetProfitRate: parsePercentInput(form.targetProfitRatePercent),
      companyNameSnapshot: form.companyName,
      companyName: form.companyName,
      regionBucketId: form.regionBucketId
    }));
    const regionRequired = computed(() => regionOptions.value.length > 0);
    const regionOptions = computed(() => {
      const options = [...props.regions];
      if (form.regionBucketId && !options.some(region => String(region.id) === String(form.regionBucketId))) {
        options.push({
          id: form.regionBucketId,
          regionName: '当前区域 #' + form.regionBucketId
        });
      }
      return options;
    });
    function resetForm() {
      const customer = props.customer || {};
      Object.assign(form, {
        id: customer.id || null,
        customerId: customer.customerId || null,
        companyName: customer.companyName || customer.customerName || customer.name || '',
        registeredRegion: customer.registeredRegion || '',
        regionBucketId: customer.regionBucketId || null,
        targetOutputAmount: customer.targetOutputAmount ?? null,
        targetProfitRatePercent: toPercentInput(customer.targetProfitRate),
        inputProductQuotas: normalizeProductQuotas(customer.inputProductQuotas || fromLegacyProductNames(customer.inputProductNames, customer.targetOutputAmount), customer.targetOutputAmount),
        outputProductQuotas: normalizeProductQuotas(customer.outputProductQuotas || fromLegacyProductNames(customer.outputProductNames, customer.targetOutputAmount), customer.targetOutputAmount)
      });
      amountWarning.value = '';
    }
    function close() {
      emit('update:modelValue', false);
    }
    function selectRegion(value) {
      const matchedRegion = props.regions.find(region => String(region.id) === String(value));
      form.regionBucketId = matchedRegion ? matchedRegion.id : null;
    }
    function validateAmount() {
      const normalizedAmount = normalizeAmountInput(form.targetOutputAmount);
      const inputAmount = Number(String(form.targetOutputAmount ?? '').trim());
      if (!Number.isFinite(inputAmount) || normalizedAmount === null || normalizedAmount <= 0) {
        ElMessage.warning('请填写有效的目标额度');
        return null;
      }
      if (inputAmount !== normalizedAmount) {
        const warning = '金额将按 100 元取整为 ' + formatInvoiceAmount(normalizedAmount);
        if (amountWarning.value !== warning) {
          amountWarning.value = warning;
          form.targetOutputAmount = normalizedAmount;
          ElMessage.warning(warning);
          return null;
        }
      }
      return normalizedAmount;
    }
    function fromLegacyProductNames(productNames, targetAmount) {
      if (!Array.isArray(productNames) || productNames.length === 0) return defaultProductQuotas(targetAmount);
      return [{
        productNames,
        displayAmount: normalizeAmountInput(targetAmount) || 0
      }];
    }
    function validateProductQuotas(value, label, targetAmount) {
      const errors = validateProductQuotaList(value, targetAmount);
      if (errors.length === 0 && quotaTotalMatched(value, targetAmount)) return true;
      ElMessage.warning(errors[0] || label);
      return false;
    }
    function validate() {
      if (!props.planId) {
        ElMessage.warning('请选择月度方案');
        return null;
      }
      if (!isEditMode.value && !form.companyName.trim()) {
        ElMessage.warning('请填写公司名称');
        return null;
      }
      if (regionRequired.value && (form.regionBucketId === null || form.regionBucketId === undefined || form.regionBucketId === '')) {
        ElMessage.warning('请选择名单区域');
        return null;
      }
      const targetOutputAmount = validateAmount();
      if (targetOutputAmount === null) return null;
      const targetProfitRate = parsePercentInput(form.targetProfitRatePercent);
      if (!Number.isFinite(targetProfitRate) || targetProfitRate < 0) {
        ElMessage.warning('请填写有效的利润率');
        return null;
      }
      if (!validateProductQuotas(form.inputProductQuotas, '进项品名组结构', targetOutputAmount)) return null;
      if (!validateProductQuotas(form.outputProductQuotas, '销项品名组结构', targetOutputAmount)) return null;
      return {
        targetOutputAmount,
        targetProfitRate
      };
    }
    function createPayload() {
      const targetOutputAmount = normalizeAmountInput(form.targetOutputAmount);
      return {
        customerId: form.customerId || null,
        companyName: form.companyName.trim(),
        registeredRegion: form.registeredRegion.trim(),
        regionBucketId: form.regionBucketId,
        targetOutputAmount,
        targetProfitRate: parsePercentInput(form.targetProfitRatePercent),
        inputProductQuotas: normalizeProductQuotas(form.inputProductQuotas, targetOutputAmount),
        outputProductQuotas: normalizeProductQuotas(form.outputProductQuotas, targetOutputAmount)
      };
    }
    function updatePayload() {
      const targetOutputAmount = normalizeAmountInput(form.targetOutputAmount);
      return {
        regionBucketId: form.regionBucketId,
        targetOutputAmount: normalizeAmountInput(form.targetOutputAmount),
        targetProfitRate: parsePercentInput(form.targetProfitRatePercent),
        inputProductQuotas: normalizeProductQuotas(form.inputProductQuotas, targetOutputAmount),
        outputProductQuotas: normalizeProductQuotas(form.outputProductQuotas, targetOutputAmount)
      };
    }
    async function submit() {
      if (submitting.value) return;
      const parsed = validate();
      if (!parsed) return;
      submitting.value = true;
      try {
        const payload = isEditMode.value ? updatePayload() : createPayload();
        const sync = isEditMode.value ? await updateEnterpriseInvoicePlanCustomer(props.planId, form.id, payload) : await addEnterpriseInvoicePlanCustomer(props.planId, payload);
        ElMessage.success(isEditMode.value ? '客户已更新' : '客户已添加');
        emit('saved', sync, payload);
        close();
      } catch (error) {
        console.error('Failed to save enterprise invoice customer', error);
        ElMessage.error(error.message || '保存客户失败');
      } finally {
        submitting.value = false;
      }
    }
    watch(() => props.modelValue, value => {
      if (value) resetForm();
    });
    watch(() => props.customer, () => {
      if (props.modelValue) resetForm();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "2xl",
        "panel-class": "max-h-[92vh]",
        "z-index": 70,
        scrollable: false,
        onClose: close
      }, {
        default: _withCtx(() => [_createElementVNode("header", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(modalTitle.value), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(isEditMode.value ? '调整当月客户额度、利润率和区域。' : '添加客户到当前月度方案，主档不存在时由后端创建。'), 1)]), _createElementVNode("button", {
          type: "button",
          class: "rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
          onClick: close
        }, [...(_cache[9] || (_cache[9] = [_createElementVNode("span", {
          class: "sr-only"
        }, "关闭", -1), _createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("main", _hoisted_4, [_createElementVNode("div", _hoisted_5, [isEditMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[10] || (_cache[10] = _createElementVNode("span", {
          class: "form-label"
        }, "公司名称", -1)), _createElementVNode("div", _hoisted_7, _toDisplayString(form.companyName || '-'), 1)])) : (_openBlock(), _createElementBlock("label", _hoisted_8, [_cache[11] || (_cache[11] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("公司名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.companyName = $event),
          type: "text",
          class: "form-input mt-1 w-full",
          placeholder: "请输入公司名称"
        }, null, 512), [[_vModelText, form.companyName]])])), !isEditMode.value ? (_openBlock(), _createElementBlock("label", _hoisted_9, [_cache[12] || (_cache[12] = _createElementVNode("span", {
          class: "form-label"
        }, "注册地", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.registeredRegion = $event),
          type: "text",
          class: "form-input mt-1 w-full",
          placeholder: "请输入注册地"
        }, null, 512), [[_vModelText, form.registeredRegion]])])) : _createCommentVNode("", true), _createElementVNode("label", _hoisted_10, [_createElementVNode("span", _hoisted_11, [_cache[13] || (_cache[13] = _createTextVNode(" 名单区域 ", -1)), regionRequired.value ? (_openBlock(), _createElementBlock("span", _hoisted_12, "*")) : _createCommentVNode("", true)]), _createVNode(_component_el_select, {
          "model-value": form.regionBucketId ?? '',
          class: "form-select mt-1 w-full",
          onChange: selectRegion
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: regionRequired.value ? '请选择名单区域' : '按注册地自动归类',
            value: ""
          }, null, 8, ["label"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionOptions.value, region => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: region.id,
              label: region.regionName || '未命名区域',
              value: region.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["model-value"])]), _createElementVNode("label", _hoisted_13, [_cache[14] || (_cache[14] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("目标额度 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.targetOutputAmount = $event),
          type: "number",
          min: "0",
          step: "100",
          class: "form-input mt-1 w-full",
          placeholder: "请输入目标额度",
          onInput: _cache[3] || (_cache[3] = $event => amountWarning.value = '')
        }, null, 544), [[_vModelText, form.targetOutputAmount]]), amountWarning.value ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(amountWarning.value), 1)) : _createCommentVNode("", true)]), _createElementVNode("label", _hoisted_15, [_cache[15] || (_cache[15] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("利润率（%） "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.targetProfitRatePercent = $event),
          type: "number",
          step: "0.01",
          min: "0",
          class: "form-input mt-1 w-full",
          placeholder: "请输入利润率"
        }, null, 512), [[_vModelText, form.targetProfitRatePercent]]), isFullProfitRate.value ? (_openBlock(), _createElementBlock("p", _hoisted_16, "100% 利润率客户只能作为链路第一个主体")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [_createVNode(InvoiceProductQuotaEditor, {
          modelValue: form.outputProductQuotas,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.outputProductQuotas = $event),
          title: "销项品名组结构",
          "target-amount": normalizedTargetAmount.value,
          class: "rounded-lg border border-slate-200 p-3"
        }, null, 8, ["modelValue", "target-amount"])]), _createElementVNode("div", _hoisted_18, [_createVNode(InvoiceProductQuotaEditor, {
          modelValue: form.inputProductQuotas,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.inputProductQuotas = $event),
          title: "进项品名组结构",
          "target-amount": normalizedTargetAmount.value,
          class: "rounded-lg border border-slate-200 p-3"
        }, null, 8, ["modelValue", "target-amount"])]), _createElementVNode("div", _hoisted_19, [_createVNode(InvoiceCustomerInvoiceRulePanel, {
          customer: invoiceRuleCustomer.value,
          "downstream-allocations": __props.downstreamAllocations,
          "downstream-tag-preferences": __props.downstreamTagPreferences,
          disabled: submitting.value,
          onConfigureDownstream: _cache[7] || (_cache[7] = $event => emit('configure-downstream', $event)),
          onConfigureTagPreference: _cache[8] || (_cache[8] = $event => emit('configure-tag-preference', $event))
        }, null, 8, ["customer", "downstream-allocations", "downstream-tag-preferences", "disabled"])])])]), _createElementVNode("footer", _hoisted_20, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          disabled: submitting.value,
          onClick: close
        }, "取消", 8, _hoisted_21), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-primary",
          disabled: submitting.value,
          onClick: submit
        }, [_createTextVNode(_toDisplayString(submitting.value ? '保存中...' : '保存'), 1)], 8, _hoisted_22)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']])])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};